import React, { useState } from "react";
import axios from "axios";

const industries = [
  "Manufacturing",
  "Finance & Banking",
  "Healthcare",
  "Retail & E-commerce",
  "Education",
  "Government",
  "Other",
];

const companySizes = [
  "1–10 employees",
  "11–50 employees",
  "51–200 employees",
  "201–500 employees",
  "500+ employees",
];

const services = [
  "AccessONE (Overview)",
  "CRM",
  "Supply Chain",
  "HR & Payroll",
  "Analytics",
  "Other",
];

export default function ContactUs() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    company: "",
    industry: "",
    companySize: "",
    services: [],
    demoDate: "",
    demoTime: "",
    notes: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDateTime, setShowDateTime] = useState(false);
  // Validation functions
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "fullName":
        if (!value.trim()) {
          error = "Full name is required";
        } else if (value.trim().length < 2) {
          error = "Name must be at least 2 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = "Name should only contain letters";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Please enter a valid email address";
        }
        break;

      case "phone":
        if (!value.trim()) {
          error = "Phone number is required";
        } else if (!/^[0-9]{10}$/.test(value.replace(/[\s-]/g, ""))) {
          error = "Please enter a valid 10-digit phone number";
        }
        break;

      case "company":
        if (!value.trim()) {
          error = "Company name is required";
        } else if (value.trim().length < 2) {
          error = "Company name must be at least 2 characters";
        }
        break;

      case "industry":
        if (!value) {
          error = "Please select an industry";
        }
        break;

      case "companySize":
        if (!value) {
          error = "Please select company size";
        }
        break;

      case "services":
        if (!value || value.length === 0) {
          error = "Please select at least one service";
        }
        break;

      case "demoDate":
        if (!value) {
          error = "Please select a preferred demo date";
        } else {
          const selectedDate = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (selectedDate < today) {
            error = "Demo date cannot be in the past";
          }
        }
        break;

      case "demoTime":
        if (!value) {
          error = "Please select a preferred time";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};

    newErrors.fullName = validateField("fullName", formData.fullName);
    newErrors.email = validateField("email", formData.email);
    newErrors.phone = validateField("phone", formData.phone);
    newErrors.company = validateField("company", formData.company);
    newErrors.industry = validateField("industry", formData.industry);
    newErrors.companySize = validateField("companySize", formData.companySize);
    newErrors.services = validateField("services", formData.services);
    newErrors.demoDate = validateField("demoDate", formData.demoDate);
    newErrors.demoTime = validateField("demoTime", formData.demoTime);

    // Remove empty errors
    Object.keys(newErrors).forEach((key) => {
      if (!newErrors[key]) delete newErrors[key];
    });

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      const updatedServices = checked
        ? [...formData.services, value]
        : formData.services.filter((s) => s !== value);

      setFormData((prev) => ({ ...prev, services: updatedServices }));

      // Mark services as touched and validate
      setTouched((prev) => ({ ...prev, services: true }));
      const error = validateField("services", updatedServices);
      setErrors((prev) => ({
        ...prev,
        services: error,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      // Validate field on change if it has been touched
      if (touched[name]) {
        const error = validateField(name, value);
        setErrors((prev) => ({
          ...prev,
          [name]: error,
        }));
      }
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    setTouched((prev) => ({ ...prev, [name]: true }));

    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched
    const allTouched = Object.keys(formData).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setTouched(allTouched);

    // Validate all fields
    const validationErrors = validateForm();
    setErrors(validationErrors);

    // If there are errors, don't submit
    if (Object.keys(validationErrors).length > 0) {
      // Scroll to first error
      const firstError = document.querySelector(".error-message");
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name: formData.fullName,
      email: formData.email,
      phoneNumber: formData.phone,
      companyName: formData.company,
      industryType: formData.industry,
      companySize: formData.companySize,
      services: formData.services,
      preferedDemoDate: formData.demoDate,
      preferedTime: formData.demoTime + ":00",
      additionalNotes: formData.notes,
    };

    try {
      console.log(payload);
      const response = await axios.post(
        "https://api.accessinfotechindia.com/api/save-data",
        payload
      );
      sessionStorage.setItem("demoSubmitted", "true");

    // ✅ Then navigate
    window.location.href = "/thank-you";
      //  window.location.href = "/thank-you";
      // setSubmitted(true);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit demo request. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div
        className="demo-form-wrapper"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          background: "linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)",
          padding: "24px",
        }}
      >
        <h2
          style={{
            fontSize: "2.25rem",
            fontWeight: "800",
            color: "#2d6198",
            marginBottom: "24px",
          }}
        >
          🎉 Thank You!
        </h2>
        <p
          style={{
            color: "#2d6198",
            textAlign: "center",
            maxWidth: "32rem",
            fontSize: "1.125rem",
          }}
        >
          Your demo request has been submitted successfully. We will contact you
          soon.
        </p>
      </div>
    );
  }

  const inputStyle = (fieldName) => ({
    width: "100%",
    padding: "12px 16px",
    border: `1px solid ${
      errors[fieldName] && touched[fieldName] ? "#ef4444" : "#d1d5db"
    }`,
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    outline: "none",
    transition: "all 0.2s",
    fontSize: "1rem",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
  });

  const errorMessageStyle = {
    color: "#ef4444",
    fontSize: "0.875rem",
    marginTop: "4px",
    display: "block",
  };

  return (
    <div
      className="demo-form-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)",
        padding: "100px 16px 16px 16px",
      }}
    >
      <div
        className="demo-form-card"
        style={{
          width: "100%",
          maxWidth: "64rem",
          backgroundColor: "#ffffff",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          borderRadius: "16px",
          border: "1px solid #e5e7eb",
        }}
      >
        <div
          className="demo-form-header"
          style={{
            backgroundColor: "#2d6198",
            color: "#ffffff",
            textAlign: "center",
            padding: "24px",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <h1
            style={{
              fontSize: "1.875rem",
              fontWeight: "700",
              letterSpacing: "0.025em",
              margin: "0",
            }}
          >
            Schedule a Demo
          </h1>
        </div>

        <div className="demo-form-body" style={{ padding: "40px" }}>
          <div
            className="demo-form-content"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "32px",
            }}
          >
            {/* Row 1: Name and Email */}
            <div
              className="demo-form-row"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                gap: "24px",
              }}
            >
              <div className="demo-form-field">
                <label
                  htmlFor="fullName"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Full Name <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <input
                  id="fullName"
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Your Name"
                  style={inputStyle("fullName")}
                />
                {errors.fullName && touched.fullName && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.fullName}
                  </span>
                )}
              </div>
              <div className="demo-form-field">
                <label
                  htmlFor="email"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Work Email <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Your Email"
                  style={inputStyle("email")}
                />
                {errors.email && touched.email && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.email}
                  </span>
                )}
              </div>
            </div>

            {/* Row 2: Phone and Company */}
            <div
              className="demo-form-row"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                gap: "24px",
              }}
            >
              <div className="demo-form-field">
                <label
                  htmlFor="phone"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Phone Number <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Phone Number"
                  style={inputStyle("phone")}
                />
                {errors.phone && touched.phone && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.phone}
                  </span>
                )}
              </div>
              <div className="demo-form-field">
                <label
                  htmlFor="company"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Company Name <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <input
                  id="company"
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="ABC Pvt Ltd"
                  style={inputStyle("company")}
                />
                {errors.company && touched.company && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.company}
                  </span>
                )}
              </div>
            </div>

            {/* Row 3: Industry and Company Size */}
            <div
              className="demo-form-row"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                gap: "24px",
              }}
            >
              <div className="demo-form-field">
                <label
                  htmlFor="industry"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Industry <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <select
                  id="industry"
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={inputStyle("industry")}
                >
                  <option value="">Select Industry</option>
                  {industries.map((ind) => (
                    <option key={ind} value={ind}>
                      {ind}
                    </option>
                  ))}
                </select>
                {errors.industry && touched.industry && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.industry}
                  </span>
                )}
              </div>
              <div className="demo-form-field">
                <label
                  htmlFor="companySize"
                  style={{
                    display: "block",
                    color: "#2D6198",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Company Size <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <select
                  id="companySize"
                  name="companySize"
                  value={formData.companySize}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={inputStyle("companySize")}
                >
                  <option value="">Select Size</option>
                  {companySizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                {errors.companySize && touched.companySize && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.companySize}
                  </span>
                )}
              </div>
            </div>

            {/* Services */}
            {/* <div className="demo-form-services">
              <label style={{
                display: 'block',
                color: '#2D6198',
                marginBottom: '16px',
                fontWeight: '600',
                fontSize: '1rem'
              }}>
                Services of Interest <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: '12px',
                padding: '20px',
                border: `1px solid ${errors.services && touched.services ? '#ef4444' : '#e5e7eb'}`,
                borderRadius: '8px',
                backgroundColor: '#f9fafb'
              }}>
                {services.map((service) => (
                  <label
                    key={service}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '8px',
                      padding: '12px 16px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      backgroundColor: '#ffffff',
                      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                    }}
                  >
                    <input
                      type="checkbox"
                      name="services"
                      value={service}
                      checked={formData.services.includes(service)}
                      onChange={handleChange}
                      style={{
                        width: '16px',
                        height: '16px',
                        accentColor: '#4f46e5',
                        flexShrink: 0,
                        marginTop: '2px'
                      }}
                    />
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#2D6198',
                      lineHeight: '1.25rem'
                    }}>
                      {service}
                    </span>
                  </label>
                ))}
              </div>
              {errors.services && touched.services && (
                <span className="error-message" style={errorMessageStyle}>
                  {errors.services}
                </span>
              )}
            </div> */}
            <div className="demo-form-services">
              <label className="demo-form-services-label">
                Services of Interest <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div
                className="demo-form-services-grid"
                style={{
                  border: `1px solid ${
                    errors.services && touched.services ? "#ef4444" : "#e5e7eb"
                  }`,
                }}
              >
                {services.map((service) => (
                  <label key={service} className="demo-form-service-item">
                    <input
                      type="checkbox"
                      name="services"
                      value={service}
                      checked={formData.services.includes(service)}
                      onChange={handleChange}
                    />
                    <span>{service}</span>
                  </label>
                ))}
              </div>
              {errors.services && touched.services && (
                <span className="error-message" style={errorMessageStyle}>
                  {errors.services}
                </span>
              )}
            </div>

            <style jsx>{`
              .demo-form-services-label {
                display: block;
                color: #2d6198;
                margin-bottom: 16px;
                font-weight: 600;
                font-size: 1rem;
              }

              .demo-form-services-grid {
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                gap: 12px;
                padding: 20px;
                border: 1px solid #e5e7eb;
                border-radius: 8px;
                background-color: #f9fafb;
              }

              .demo-form-service-item {
                display: flex;
                align-items: flex-start; /* top-align checkbox and text */
                gap: 8px;
                padding: 12px 16px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                cursor: pointer;
                background-color: #ffffff;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                transition: background-color 0.2s;
              }

              .demo-form-service-item:hover {
                background-color: #eef2ff;
              }

              .demo-form-service-item input[type="checkbox"] {
                width: 16px;
                height: 16px;
                accent-color: #2d6198;
                flex-shrink: 0;
                margin-top: 2px; /* aligns checkbox top with text */
              }

              .demo-form-service-item span {
                font-size: 0.875rem;
                font-weight: 500;
                color: #2d6198;
                line-height: 1.25rem; /* ensures proper alignment with checkbox */
              }

              @media (min-width: 768px) {
                .demo-form-services-grid {
                  grid-template-columns: repeat(3, minmax(0, 1fr));
                }
              }

              @media (min-width: 1024px) {
                .demo-form-services-grid {
                  grid-template-columns: repeat(6, minmax(0, 1fr));
                }
              }
            `}</style>

            {/* Row 4: Demo Date and Time */}
            {/* <div className="demo-form-row" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
              gap: '24px'
            }}>
              <div className="demo-form-field">
                <label htmlFor="demoDate" style={{
                  display: 'block',
                  color: '#2D6198',
                  marginBottom: '12px',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  Preferred Demo Date <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  id="demoDate"
                  type="date"
                  name="demoDate"
                  value={formData.demoDate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  min={new Date().toISOString().split('T')[0]}
                  style={inputStyle('demoDate')}
                />
                {errors.demoDate && touched.demoDate && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.demoDate}
                  </span>
                )}
              </div>
              <div className="demo-form-field">
                <label htmlFor="demoTime" style={{
                  display: 'block',
                  color: '#2D6198',
                  marginBottom: '12px',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  Preferred Time <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  id="demoTime"
                  type="time"
                  name="demoTime"
                  value={formData.demoTime}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={inputStyle('demoTime')}
                />
                {errors.demoTime && touched.demoTime && (
                  <span className="error-message" style={errorMessageStyle}>
                    {errors.demoTime}
                  </span>
                )}
              </div>
            </div> */}
            {/* Row 4: Demo Date and Time */}

            {/* Selected Date & Time Display */}
            {/* <div style={{
  fontSize: '1rem',
  fontWeight: '600',
  color: '#2D6198',
  marginBottom: '16px'
}}>
  {formData.demoDate && formData.demoTime ? (
    <span>
      Selected Demo:{" "}
      {new Date(formData.demoDate + 'T' + formData.demoTime).toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })}
    </span>
  ) : (
    <span>Please select a date & time</span>
  )}
</div> */}

            <div>
              <button
                type="button"
                onClick={() => setShowDateTime((prev) => !prev)}
                style={{
                  // padding: '12px 16px',
                  borderRadius: "8px",
                  border: "1px solid #2d6198", // optional: match border color
                  backgroundColor: "#2d6198",
                  color: "#ffffff", // make text readable on dark background
                  cursor: "pointer",
                  marginTop: "8px",
                  marginBottom: "8px",
                  // width: '50%',
                  padding: "16px",
                  fontWeight: "700",
                  fontSize: "1.125rem",
                }}
                // style={{ padding: '12px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#ffffff', cursor: 'pointer', marginTop: '8px',marginBottom:'8px' }}
              >
                {showDateTime ? "Select Date & Time" : "Select Date & Time"}
              </button>

              {showDateTime && (
                <div className="demo-form-datetime">
                  {/* <label style={{
                display: 'block',
                color: '#2D6198',
                marginBottom: '16px',
                fontWeight: '600',
                fontSize: '1rem'
              }}>
                Select a Date & Time <span style={{ color: '#ef4444' }}>*</span>
              </label> */}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: "24px",
                      padding: "24px",
                      border: `1px solid ${
                        (errors.demoDate || errors.demoTime) &&
                        (touched.demoDate || touched.demoTime)
                          ? "#ef4444"
                          : "#e5e7eb"
                      }`,
                      borderRadius: "12px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: "700",
                            color: "#2D6198",
                          }}
                        >
                          {formData.demoDate
                            ? new Date(
                                formData.demoDate + "T00:00:00"
                              ).toLocaleDateString("en-US", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })
                            : "Select a date"}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(7, 1fr)",
                          gap: "8px",
                        }}
                      >
                        {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                          (day) => (
                            <div
                              key={day}
                              style={{
                                textAlign: "center",
                                fontSize: "0.75rem",
                                fontWeight: "600",
                                color: "#2D6198",
                                padding: "8px 0",
                              }}
                            >
                              {day}
                            </div>
                          )
                        )}

                        {(() => {
                          const today = new Date();
                          const currentMonth = today.getMonth();
                          const currentYear = today.getFullYear();
                          const firstDay = new Date(
                            currentYear,
                            currentMonth,
                            1
                          ).getDay();
                          const daysInMonth = new Date(
                            currentYear,
                            currentMonth + 1,
                            0
                          ).getDate();
                          const dates = [];

                          for (let i = 0; i < firstDay; i++) {
                            dates.push(<div key={`empty-${i}`} />);
                          }

                          for (let day = 1; day <= daysInMonth; day++) {
                            const dateStr = `${currentYear}-${String(
                              currentMonth + 1
                            ).padStart(2, "0")}-${String(day).padStart(
                              2,
                              "0"
                            )}`;
                            const isPast =
                              new Date(dateStr) <
                              new Date(today.toISOString().split("T")[0]);
                            const isSelected = formData.demoDate === dateStr;

                            dates.push(
                              <button
                                key={day}
                                type="button"
                                disabled={isPast}
                                onClick={() => {
                                  if (!isPast) {
                                    handleChange({
                                      target: {
                                        name: "demoDate",
                                        value: dateStr,
                                      },
                                    });
                                    setTouched((prev) => ({
                                      ...prev,
                                      demoDate: true,
                                    }));
                                  }
                                }}
                                style={{
                                  padding: "12px",
                                  borderRadius: "8px",
                                  border: "none",
                                  backgroundColor: isSelected
                                    ? "#2d6198"
                                    : isPast
                                    ? "transparent"
                                    : "#ffffff",
                                  color: isSelected
                                    ? "#ffffff"
                                    : isPast
                                    ? "#d1d5db"
                                    : "#2D6198",
                                  fontWeight: isSelected ? "600" : "500",
                                  cursor: isPast ? "not-allowed" : "pointer",
                                  fontSize: "0.875rem",
                                  transition: "all 0.2s",
                                  outline: "none",
                                }}
                                onMouseEnter={(e) => {
                                  if (!isPast && !isSelected) {
                                    e.target.style.backgroundColor = "#f3f4f6";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isPast && !isSelected) {
                                    e.target.style.backgroundColor = "#ffffff";
                                  }
                                }}
                              >
                                {day}
                              </button>
                            );
                          }

                          return dates;
                        })()}
                      </div>
                      {errors.demoDate && touched.demoDate && (
                        <span
                          className="error-message"
                          style={{ ...errorMessageStyle, marginTop: "8px" }}
                        >
                          {errors.demoDate}
                        </span>
                      )}
                    </div>

                    <div>
                      <div
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          color: "#2d6198",
                          marginBottom: "12px",
                        }}
                      >
                        Available Time Slots
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: "12px",
                          maxHeight: "240px",
                          overflowY: "auto",
                          padding: "4px",
                        }}
                      >
                        {[
                          "09:00",
                          "09:30",
                          "10:00",
                          "10:30",
                          "11:00",
                          "11:30",
                          "12:00",
                          "12:30",
                          "13:00",
                          "13:30",
                          "14:00",
                          "14:30",
                          "15:00",
                          "15:30",
                          "16:00",
                          "16:30",
                          "17:00",
                          "17:30",
                        ].map((time) => {
                          const isSelected = formData.demoTime === time;

                          // Determine if the time is past
                          let isPastTime = false;
                          if (formData.demoDate) {
                            const selectedDate = new Date(formData.demoDate);
                            const now = new Date();

                            // If the selected date is today, compare times
                            const isToday =
                              selectedDate.toDateString() ===
                              now.toDateString();

                            if (isToday) {
                              const [hours, minutes] = time
                                .split(":")
                                .map(Number);
                              const slotTime = new Date(selectedDate);
                              slotTime.setHours(hours, minutes, 0, 0);

                              if (slotTime < now) {
                                isPastTime = true;
                              }
                            }
                          }

                          return (
                            <button
                              key={time}
                              type="button"
                              disabled={isPastTime}
                              onClick={() => {
                                if (!isPastTime) {
                                  handleChange({
                                    target: { name: "demoTime", value: time },
                                  });
                                  setTouched((prev) => ({
                                    ...prev,
                                    demoTime: true,
                                  }));
                                }
                              }}
                              style={{
                                padding: "12px 16px",
                                borderRadius: "8px",
                                border: isSelected
                                  ? "2px solid #2d6198"
                                  : "1px solid #e5e7eb",
                                backgroundColor: isSelected
                                  ? "#ecfdf5"
                                  : isPastTime
                                  ? "#f3f4f6"
                                  : "#ffffff",
                                color: isPastTime ? "#9ca3af" : "#2D6198",
                                fontWeight: isSelected ? "600" : "500",
                                cursor: isPastTime ? "not-allowed" : "pointer",
                                fontSize: "0.875rem",
                                transition: "all 0.2s",
                                outline: "none",
                                textAlign: "center",
                              }}
                              onMouseEnter={(e) => {
                                if (!isSelected && !isPastTime) {
                                  e.target.style.backgroundColor = "#f9fafb";
                                  e.target.style.borderColor = "#d1d5db";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelected && !isPastTime) {
                                  e.target.style.backgroundColor = "#ffffff";
                                  e.target.style.borderColor = "#e5e7eb";
                                }
                              }}
                            >
                              {time}
                            </button>
                          );
                        })}

                        {/* {[
                      '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
                      '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
                      '15:00', '15:30', '16:00', '16:30', '17:00', '17:30'
                    ].map((time) => {
                      const isSelected = formData.demoTime === time;
                      return (
                        <button
                          key={time}
                          type="button"
                          onClick={() => {
                            handleChange({ target: { name: 'demoTime', value: time } });
                            setTouched(prev => ({ ...prev, demoTime: true }));
                          }}
                          style={{
                            padding: '12px 16px',
                            borderRadius: '8px',
                            border: isSelected ? '2px solid #2d6198' : '1px solid #e5e7eb',
                            backgroundColor: isSelected ? '#ecfdf5' : '#ffffff',
                            color: isSelected ? '#2d6198' : '#2D6198',
                            fontWeight: isSelected ? '600' : '500',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            transition: 'all 0.2s',
                            outline: 'none',
                            textAlign: 'center'
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.target.style.backgroundColor = '#f9fafb';
                              e.target.style.borderColor = '#d1d5db';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#e5e7eb';
                            }
                          }}
                        >
                          {time}
                        </button>
                      );
                    })} */}
                      </div>
                      {errors.demoTime && touched.demoTime && (
                        <span
                          className="error-message"
                          style={{ ...errorMessageStyle, marginTop: "8px" }}
                        >
                          {errors.demoTime}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* {showDateTime && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginTop: '16px' }}>
                  <div>
                    <input type="date" name="demoDate" value={formData.demoDate} onChange={handleChange} onBlur={handleBlur} style={inputStyle('demoDate')} />
                    {errors.demoDate && touched.demoDate && <span style={errorMessageStyle}>{errors.demoDate}</span>}
                  </div>
                  <div>
                    <input type="time" name="demoTime" value={formData.demoTime} onChange={handleChange} onBlur={handleBlur} style={inputStyle('demoTime')} />
                    {errors.demoTime && touched.demoTime && <span style={errorMessageStyle}>{errors.demoTime}</span>}
                  </div>
                </div>
              )} */}

            {/* Notes */}
            <div className="demo-form-field">
              <label
                htmlFor="notes"
                style={{
                  display: "block",
                  color: "#2D6198",
                  marginBottom: "12px",
                  fontWeight: "600",
                  fontSize: "1rem",
                }}
              >
                Additional Notes
              </label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows="4"
                placeholder="Anything specific you want to mention..."
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  outline: "none",
                  transition: "all 0.2s",
                  fontSize: "1rem",
                  resize: "vertical",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                }}
              />
            </div>
          </div>
        </div>

        {/* Card Footer */}
        <div
          className="demo-form-footer"
          style={{
            backgroundColor: "#f9fafb",
            padding: "32px 40px",
            borderRadius: "0 0 16px 16px",
          }}
        >
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={{
              width: "100%",
              background: isSubmitting
                ? "linear-gradient(90deg, #9ca3af 0%, #9ca3af 100%)"
                : "linear-gradient(90deg, #2d6198 0%, #2d6198 100%)",
              color: "#ffffff",
              padding: "16px",
              borderRadius: "8px",
              fontWeight: "700",
              fontSize: "1.125rem",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s",
              outline: "none",
            }}
          >
            {isSubmitting ? "Submitting..." : "Schedule a Demo Meeting"}
          </button>
        </div>
      </div>

      <style jsx>{`
        @media (min-width: 768px) {
          .demo-form-row {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }
        }
      `}</style>
    </div>
  );
}
